



import Vue from "vue";
import Component from "vue-class-component";
import ModDownloadJobs from "@/components/arma/mods/download/ModDownloadJobs.vue";

@Component({
  components: { ModDownloadJobs },
  metaInfo: {
    title: "Mod Downloads – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "See the status of all mod downloads." },
      { vmid: "og:title", property: "og:title", content: "Mod Downloads – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "See the status of all mod downloads." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/mod-downloads" },
    ],
  },
})
export default class Home extends Vue {}
